module.exports = __webpack_public_path__ + "static/img/2023_9_8_13.bee7057b.bee7057.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_13.bee7057b.png
// module id = tbT5
// module chunks = 0